__turbopack_context__.v({
  "className": "raleway_1c60014f-module__qf3GPq__className",
  "variable": "raleway_1c60014f-module__qf3GPq__variable",
});
